import { Suspense, lazy } from 'react';
import { useMenuData } from '../../../primitives/menu';
import { useDonutData } from '../providers/data';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyDataTableModal = /*#__PURE__*/lazy(() => import('../../../primitives/accessibility/DataTable').then(module => ({
  default: module.DataTableModal
})));
export function DataTable() {
  const {
    showDataTable,
    closeDataTable
  } = useMenuData();
  const {
    data
  } = useDonutData();
  return showDataTable ? /*#__PURE__*/_jsx(Suspense, {
    fallback: /*#__PURE__*/_jsx("div", {
      style: {
        visibility: 'hidden'
      }
    }),
    children: /*#__PURE__*/_jsx(LazyDataTableModal, {
      data: data,
      closeModal: closeDataTable
    })
  }) : null;
}